import { render, staticRenderFns } from "./AddModalContent.vue?vue&type=template&id=ba6f1194&scoped=true&"
import script from "./AddModalContent.vue?vue&type=script&lang=js&"
export * from "./AddModalContent.vue?vue&type=script&lang=js&"
import style0 from "./AddModalContent.vue?vue&type=style&index=0&id=ba6f1194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f1194",
  null
  
)

export default component.exports